import toast from 'react-hot-toast'

interface AxiosLikeError {
  response?: {
    status?: number
    data?: Record<string, unknown>
  }
  message?: string
}

function asAxiosLike(error: unknown): AxiosLikeError | null {
  if (typeof error !== 'object' || error === null) return null
  if ('response' in error || 'message' in error) return error as AxiosLikeError
  return null
}

export function getErrorMessage(error: unknown, fallbackMessage = 'Ocorreu um erro inesperado.'): string {
  if (typeof error === 'string') return error

  const axios = asAxiosLike(error)
  if (!axios) return fallbackMessage

  const data = axios.response?.data
  if (data) {
    const candidates = ['error', 'message', 'reason', 'detail']
    for (const key of candidates) {
      const val = data[key]
      if (typeof val === 'string' && val.trim()) return val
    }
  }

  if (axios.message) return axios.message

  return fallbackMessage
}

export function getErrorCode(error: unknown): string | null {
  const axios = asAxiosLike(error)
  if (!axios?.response?.status) return null
  return String(axios.response.status)
}

export function toastError(error: unknown, fallbackMessage?: string): void {
  toast.error(getErrorMessage(error, fallbackMessage))
}

export function toastSuccess(message: string): void {
  toast.success(message)
}
